import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { ARAC_TOOLS } from "./Header";
import { Heart, Mail, Star, User, Sparkles, ArrowRight } from "lucide-react";

const PANEL_TABS = [
  { label: "Favorilerim", icon: Heart, desc: "Beğendiğiniz mekan ve firmaları tek yerde saklayın." },
  { label: "Tekliflerim", icon: Mail, desc: "Firmalara gönderdiğiniz teklif taleplerini takip edin." },
  { label: "Yorumlarım", icon: Star, desc: "Yazdığınız değerlendirmeleri görüntüleyin." },
  { label: "Profil", icon: User, desc: "Ad ve şifre bilgilerinizi güncelleyin." },
];

const WelcomeTour = ({ open, onClose, memberName }) => {
  const tools = ARAC_TOOLS.filter((t) => t.key !== "favorilerim");
  const items = [
    ...tools.map((t) => ({ label: t.label, icon: t.icon, desc: t.desc })),
    ...PANEL_TABS,
  ];

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-2xl p-0 overflow-hidden gap-0" data-testid="welcome-tour-dialog">
        <div className="relative bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B] px-6 py-8 text-center text-white">
          <div className="w-14 h-14 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center mx-auto mb-4">
            <Sparkles className="w-7 h-7 text-white" />
          </div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold">
            Hoş geldin{memberName ? `, ${memberName.split(" ")[0]}` : ""}!
          </h2>
          <p className="text-white/85 text-sm mt-2 max-w-md mx-auto">
            Düğün hazırlığını kolaylaştıracak tüm araçlar üyelik panelinde. İşte kısaca neler yapabilirsin:
          </p>
        </div>

        <div className="px-6 py-6 max-h-[52vh] overflow-y-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {items.map((it) => {
              const I = it.icon;
              return (
                <div key={it.label} className="flex items-start gap-3 p-3 rounded-xl border border-[#F0DDE0] bg-[#FDF8F5]">
                  <div className="shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B] flex items-center justify-center">
                    <I className="w-4.5 h-4.5 text-white" />
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-[#2A2224]">{it.label}</div>
                    <div className="text-xs text-[#7C6E70] mt-0.5 leading-snug">{it.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="px-6 pb-6 pt-1">
          <button onClick={onClose} data-testid="welcome-tour-start"
            className="w-full h-11 rounded-xl bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white font-medium flex items-center justify-center gap-2 hover:shadow-md transition-all">
            Hadi Başlayalım <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeTour;
